import axios from '../../axios';

const DeleteRequests = (url, _this, callback) => {
    _this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
    }).then(() => {
        return axios.delete(url).then((response) => {
        }).catch(() => {
            _this.$message({
                type: 'info',
                message: '网络请求失败！'
            });
        })
    }).catch(() => {

    })
}

const requestsPost = (url, data) => {
    return axios({
        method: 'post',
        url: url,
        data: data
    })
}



const requestsGet = (url, data) => {
    return axios.get(url, {
        params: data
    })
}


const requestsFile = (url, data) => {
    return axios.get(url, {
        params: data,
        responseType: 'arraybuffer'
    })
}

export {
    DeleteRequests, //删除
    requestsPost, //post请求
    requestsGet, //get请求
    requestsFile //导出数据
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js